import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import styles from './styles.scss';

import RealtorPopup from 'components/RealtorPopup';

import { setPopUp } from 'actions/environment';
import { ROOT_URL } from 'constants/Config';
import { formatPhoneNumber, addUrlProtocol } from 'utils';

import iconPhoneBlack from 'assets/images/icons/icon-phone-black.svg';
import iconPhoneBlue from 'assets/images/icons/icon-phone-blue.svg';
import iconEmailBlack from 'assets/images/icons/icon-email-black.svg';
import iconEmailBlue from 'assets/images/icons/icon-email-blue.svg';
import iconSocVk from 'assets/images/icons/social-vk.svg';
import iconSocOk from 'assets/images/icons/social-ok.svg';
import iconSocFb from 'assets/images/icons/social-fb.svg';
import iconSocInst from 'assets/images/icons/social-inst.svg';
import iconSocYoutube from 'assets/images/icons/social-youtube.svg';

import iconUser from 'assets/images/icons/icon-user-sq.svg';
import { withTranslation } from 'react-i18next';
import { linkifyText } from '../Building/Main/helper';

class RealtorCard extends Component {
  showPopup = () => {
    this.props.setPopUp(<RealtorPopup agency={this.props.agency} />, {
      closeStyleName: 'Default',
      contentStyleName: 'Default',
      closeIcon: 'default',
      closeClassName: styles.PopupCompanyClose,
      backgroundClassName: styles.PopupCompanyBg,
      contentClassName: styles.PopupCompanyContent,
      lockScroll: true,
    });
  };

  render() {
    const {
      className,
      firstName,
      lastName,
      position,
      agency,
      description,
      phone,
      email,
      vk,
      ok,
      facebok,
      instagram,
      youtube,
      avatarId,
      company,
      t,
      onPhoneClick,
    } = this.props;

    const links = [
      { url: vk, icon: iconSocVk },
      { url: ok, icon: iconSocOk },
      { url: facebok, icon: iconSocFb },
      { url: instagram, icon: iconSocInst },
      { url: youtube, icon: iconSocYoutube },
    ].filter(({ url }) => url);

    return firstName ? (
      <div className={cn(styles.RealtorBlock, className)}>
        <div className={styles.RealtorInfo}>
          <div className={styles.RealtorAvatar}>
            <img
              src={
                avatarId ? `${ROOT_URL}/image/get?id=${avatarId}&preset=profile_avatar` : iconUser
              }
              alt=""
            />
          </div>
          <p className={styles.RealtorName}>
            {firstName} {lastName}
          </p>
          {agency && (
            <p className={styles.RealtorPosition}>
              <span className={styles.Position}>{position}</span>
              {(agency.name || company) && t('components.realtorCard.in')}
              {agency.website ? (
                <a
                  href={
                    agency.website.startsWith('http://') || agency.website.startsWith('https://')
                      ? agency.website
                      : `https://${agency.website}`
                  }
                  className={styles.AgencyName}
                  target="_blank"
                >
                  &nbsp;{agency.name || company}
                </a>
              ) : (
                <span
                  // onClick={agency.name ? this.showPopup : (_) => _}
                  className={styles.AgencyNameNoLink}
                >
                  &nbsp;{agency.name || company}
                </span>
              )}
            </p>
          )}
          {description && (
            <p className={styles.RealtorDescrip}>{linkifyText(description, 10000)}</p>
          )}
        </div>
        <ul className={styles.RealtorContacts}>
          <li onClick={onPhoneClick}>
            <a href={`tel:${phone}`}>
              <img src={iconPhoneBlack} alt="" className={styles.RealtorContactsIcon} />
              {formatPhoneNumber(phone)}
            </a>
          </li>
          {email ? (
            <li>
              <a href={`mailto:${email}`}>
                <img src={iconEmailBlack} alt="" className={styles.RealtorContactsIcon} />
                {email}
              </a>
            </li>
          ) : null}
        </ul>
        {links.length ? (
          <div className={styles.RealtorSocial}>
            <p className={styles.RealtorSocialTitle}>{t('components.realtorCard.title')}</p>
            <div className={styles.RealtorSocialLinks}>
              {links.map(({ url, icon }) => (
                <a
                  href={addUrlProtocol(url)}
                  key={icon}
                  className={styles.RealtorSocialLink}
                  target="_blank"
                >
                  <img src={icon} alt="" />
                </a>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    ) : null;
  }
}

export default connect(null, { setPopUp })(withTranslation()(RealtorCard));



// WEBPACK FOOTER //
// ./src/components/RealtorCard/RealtorCard.js